import {
  Component,
  HostBinding,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AppColorKeys } from '@fc-core/constants/colors';
import { AppIconsType, iconsList, iconsHashes } from '@fc-shared/ui/icon/icons';

@Component({
  selector: 'fc-icon',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: inline-block;
      mask-size: 100%;
      mask-repeat: no-repeat;
      mask-position: center;
      -webkit-mask-size: 100%;
      -webkit-mask-repeat: no-repeat;
      -webkit-mask-position: center;
      width: 24px;
      height: 24px;
      z-index: 1;
    }
  `,
})
export class IconComponent {
  size = input<number>(24);
  icon = input.required({
    transform: (icon: AppIconsType) =>
      `${iconsList[icon]}?v=${iconsHashes[icon]}`,
  });
  color = input<AppColorKeys>('secondary400' as AppColorKeys);

  @HostBinding('class') get colorClass() {
    return 'bg-' + this.color().replace(/(\d+)$/, '-$1');
  }

  @HostBinding('style.mask-image') get maskImage() {
    return `url(${this.icon()})`;
  }

  @HostBinding('style.-webkit-mask-image') get webkitMaskImage() {
    return `url(${this.icon()})`;
  }

  @HostBinding('style.width.px') get width() {
    return this.size();
  }

  @HostBinding('style.height.px') get height() {
    return this.size();
  }

  @HostBinding('style.min-width.px') get minWidth() {
    return this.size();
  }

  @HostBinding('style.min-height.px') get minHeight() {
    return this.size();
  }
}
